'use client';

import {
	Center, Flex, Icon,
	Stack,
	Text,
} from '@chakra-ui/react';
import React from 'react';
import { IoSearchSharp } from 'react-icons/io5';
import z from 'zod';

import { AppRoutes } from '@/constants';
import { JobSearchCheckboxFilter } from '@/modules/job/presentation/components';
import { JobSearch } from '@/modules/job/presentation/composites';
import {
	benefitsOptions, companyFeatureOptions, featureOptions, jobFeatureOptions, recommendOptions,
} from '@/modules/job/presentation/constants';
import { NextLinkButton } from '@/modules/navigation';
import { ContentContainer } from '@/modules/shared';

import { Form } from '@packages/hook-form-wrapper';

export const JobSearchScreen = () => {
	return (
		<Form.Provider onSubmit={() => {}} schema={z.object({})}>
			<ContentContainer maxW="2xl" mb="lg" position="relative">
				<Text color="primary.100" mb="md" textStyle="h3">Detail Search Condition</Text>
				<Stack gap="sm">
					<JobSearch />
					<JobSearchCheckboxFilter items={recommendOptions} title="Recommend" />
					<JobSearchCheckboxFilter items={featureOptions} title="Feature" />
					<JobSearchCheckboxFilter items={benefitsOptions} title="Benefits" />
					<JobSearchCheckboxFilter items={jobFeatureOptions} title="Job Feature" />
					<JobSearchCheckboxFilter items={companyFeatureOptions} title="Company Feature" />
				</Stack>
			</ContentContainer>
			<Center
				bg="white"
				bottom={0}
				boxShadow="md"
				mt="lg"
				p={6}
				position="sticky"
			>
				<Flex alignItems="center" gap="sm">
					<Text>
						1120 Result
					</Text>
					<NextLinkButton href={AppRoutes.jobs.searchResults} size="md" w="fit">
						<Icon as={IoSearchSharp} />
						Search
					</NextLinkButton>
				</Flex>
			</Center>
		</Form.Provider>
	);
};
